"use client";

import { useSearchParams } from "next/navigation";
import { useCallback } from "react";

import { AnnouncementCategory } from "@/contexts/queries/announcements";

export function useCategory() {
  const searchParams = useSearchParams();

  const category = searchParams.get("category") as AnnouncementCategory | null;

  const setCategory = useCallback(
    (category: AnnouncementCategory | null) => {
      const params = new URLSearchParams(Array.from(searchParams.entries()));
      if (category) {
        params.set("category", category);
      } else {
        params.delete("category");
      }
      window.history.pushState(null, "", `?${params.toString()}`);
    },
    [searchParams],
  );

  return { category, setCategory };
}
